import { Icon } from './icons'
import type { IconName } from './icons'
import styles from './in-development.module.css'

type Props = {
  icon: IconName
  title: string
  text: string
  children?: React.ReactNode
}

export function InDevelopment({ icon, title, text, children }: Props) {
  return (
    <section className={styles.wrap}>
      <span className={styles.mark} aria-hidden="true">
        <Icon name={icon} size={30} />
      </span>
      <p className={styles.eyebrow}>В разработке</p>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.text}>{text}</p>
      {children}
    </section>
  )
}
